import {Badge, Group} from "@mantine/core";
import {PlannerPlanStatusSummary} from "../plannerTypes.ts";

type ProductionPlannerStatusBadgesProps = {
    summary: PlannerPlanStatusSummary;
    mode?: "full" | "compact";
};

export default function ProductionPlannerStatusBadges({
    summary,
    mode = "full",
}: ProductionPlannerStatusBadgesProps) {
    if (mode === "compact") {
        return (
            <Group gap={4}>
                {summary.active > 0 ? <Badge size="xs" color="green" variant="light">Active</Badge> : null}
                {summary.queued > 0 ? <Badge size="xs" color="blue" variant="light">Queued</Badge> : null}
                {summary.completed > 0 ? <Badge size="xs" color="gray" variant="light">Complete</Badge> : null}
                {summary.pending > 0 || summary.total === 0 ? <Badge size="xs" color="grape" variant="light">Pending</Badge> : null}
            </Group>
        );
    }

    return (
        <Group gap={6}>
            <Badge size="sm" color="green" variant="light">
                Active {summary.active}
            </Badge>
            <Badge size="sm" color="blue" variant="light">
                Queued {summary.queued}
            </Badge>
            <Badge size="sm" color="gray" variant="light">
                Completed {summary.completed}
            </Badge>
            <Badge size="sm" color="grape" variant="light">
                Pending {summary.pending}
            </Badge>
        </Group>
    );
}
